import React, { useState } from 'react'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import InputAdornment from '@material-ui/core/InputAdornment'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import { setInputmultiLanguageValue, valMax } from 'utils'
import InputWrapper from './InputWrapper'
import InputIcon from './InputIcon'

const style = makeStyles(theme => ({
  valid: {
    border: `none`,
    borderRadius: 5,
  },
  viewMode: {
    color: `black`,
    border: `none`,
    background: `transparent`,
    padding: theme.spacing(1.5, 0),
    '& > input': {
      background: `transparent`,
    },
  },
  textWarning: {
    color: `#FF5252`,
  },
  textRight: {
    display: `block`,
    textAlign: `right`,
  },
}))

export default function TextInputWrapper({
  id,
  label,
  error, // Puede ser boolean o string
  isRequired = false,
  onBlur,
  onChange,
  value,
  name,
  type = `text`,
  inputType = `text`,
  autocompleteData,
  rules: { min = 0, max, required = false ,format = null } = {},
  size = `small`,
  InputProps = {},
  disabled = false,
  placeholder = ``,
  align = `left`,
  fullWidth = false,
  xs = 12,
  md = 12,
  multiLanguage = false,
  languageKey = ``,
  icon = undefined,
  addonBefore = false,
  isValid = false,
  useNameInsteadId = false,
  color = `primary`,
  viewMode = false,
  showCounter = false,
  maxMessage = `Se ha alcanzado el máximo de caracteres permitido`,
  useOnChangeInsteadOnBlur = false,
  ...rest
}) {
  const classes = style()
  const [localValue, setLocalValue] = useState(multiLanguage ? value[languageKey] : value)
  const isMaxCounter = max && (localValue ? localValue.length : 0) >= max
  const haveErrorWithLang = languageKey ? error && error[languageKey] : error
  const [customType, setCustomType] = useState(type)
  const [urlError, setUrlError] = useState('')

  const isPasswordType = type === `password`

  function togglePasswordType() {
    if (isPasswordType) {
      // only if type === password from original source
      setCustomType(customType === `text` ? `password` : `text`)
    }
  }

  function isValidURL(url) {
    const regex = /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|\d{1,3}(\.\d{1,3}){3}|localhost)(:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(#[-a-z\d_]*)?$/i;
    return regex.test(url);
  }

  function handleNewValue(nextValue, name) {
    const listenFunction = useOnChangeInsteadOnBlur ? onChange : onBlur

    // Validar URL si el formato es URL
    
    if (format === 'url' && !isValidURL(nextValue)) {
      console.log('ERROR DE URL')
      setUrlError('URL no válida')
    } else {
      setUrlError('')
    }

    if (format==='phone') {
      nextValue=nextValue.replace("+56", "").trim();
      console.log('remove prefix',nextValue);
    }

    return listenFunction({
      name: useNameInsteadId ? name : id,
      value: multiLanguage
        ? setInputmultiLanguageValue({
            languageKey,
            value: {
              current: value,
              next: nextValue,
            },
          })
        : nextValue,
      id,
      languageKey,
    })
  }

  function handleKeyUpValue(value) {
    if (valMax(value, max)) {
      handleNewValue(value.slice(0, max), id)
    } else {
      setLocalValue(isMaxCounter ? localValue : value)
    }
  }

  return (
    <InputWrapper
      label={label}
      isRequired={isRequired || required}
      align={align}
      type={inputType}
      error={error || urlError} // Incluir el error de URL
      fullWidth={fullWidth}
      xs={xs}
      md={md}
      languageKey={languageKey}
      disabled={disabled}
      
      {...rest}
    >
      <TextField
        placeholder={placeholder}
        defaultValue={localValue}
        id={name}
        name={name}
        type={isPasswordType ? customType : type}
        disabled={viewMode || disabled}
        {...(useOnChangeInsteadOnBlur
          ? {
              onChange: ({ target: { value, name } }) => handleNewValue(value, name, id),
            }
          : {
              onBlur: ({ target: { value, name } }) => handleNewValue(value, name, id),
            })}
        min={type === `number` ? min : null}
        max={max}
        color={color}
        error={!!haveErrorWithLang || !!urlError} // Verificar si hay un error de URL
        InputLabelProps={{
          shrink: true,
        }}
        InputProps={{
          ...InputProps,
          ...(icon && {
            endAdornment: <InputIcon icon={icon} onClick={togglePasswordType} />,
          }),
          ...(addonBefore && {
            startAdornment: <InputAdornment position="start">{addonBefore}</InputAdornment>,
          }),
          className: isValid ? `validInput` : ``,
          inputProps: { maxLength: type === `text` ? max : null, autoFocus: false },
        }}
        size={size}
        className={`${isValid && classes.valid} ${viewMode && classes.viewMode}`}
        onKeyUp={({ target: { value } }) => handleKeyUpValue(value)}
      />
      
      {
        format=='url' && urlError !='' ? 
        <Grid container direction="row" justify="space-between" alignItems="flex-start">
          <Grid item xs={10}>
            
              <Typography variant="caption" className={classes.textWarning}>
                Error de url
              </Typography>
         
          </Grid>
         
        </Grid>: <></>
      }
      {showCounter && (
        <Grid container direction="row" justify="space-between" alignItems="flex-start">
          <Grid item xs={10}>
            {isMaxCounter && (
              <Typography variant="caption" className={classes.textWarning}>
                {maxMessage}
              </Typography>
            )}
          </Grid>
          <Grid item xs={2}>
            <Typography variant="caption" className={classes.textRight}>
              {max && localValue ? max - localValue.length : max}
            </Typography>
          </Grid>
        </Grid>
      )}
    </InputWrapper>
  )
}
